import React, { useState, useEffect } from "react"
import { SettingItem } from "./setting/other/SettingsPanel"

interface SliderProps {
    min: number
    max: number
    value?: number
    onChange: ((e: any) => void)
    step?: number
    ticks?: number[]
}

export function Slider(props: SliderProps) {

    const stepToTick = (value: number) => {
        if (props.ticks == null) return value;

        let res = props.ticks.findIndex(e => (e >= value));
        if (res === -1) return 2;
        return res;
    }
    const tickToStep = (tick: number) => {
        if (props.ticks == null) return tick;

        let res = props.ticks[tick];
        if (res == null) return 15;
        return res;
    }

    const [showedValue, setShowedValue] = useState(stepToTick((props.value != null ? props.value : props.min)));
    useEffect(() => {
        setShowedValue(stepToTick((props.value != null ? props.value : props.min)))
    }, [props])

    const formatTick = (tick: number) => {
        return (
            <div className="slide-input-tick-container pb-4">
                <span className="text-xs text-gray-600 text-center">
                    {tick}
                </span>
            </div>
        );
    }

    const getTicks = (min: number, max: number, step?: number) => {
        const ticks: React.JSX.Element[] = [];

        if (step == null) step = 1;
        if (((max - min) / step) > 10) {
            step = 1;
        }

        for (let tick = min; tick <= max; tick += step) {
            ticks.push(formatTick(tick));
        }
        return ticks;
    }

    const localChange = (event) => {
        setShowedValue(event.target.value)
    }

    return (
        <div className={"h-full pt-1 grid items-center w-full"}>
            <div className="flex justify-between pb-1 w-full px-1.5">
                {props.ticks == null ?
                    getTicks(props.min, props.max, props.step).map(tick => (tick)) :
                    props.ticks.map(tick => formatTick(tick))
                }
            </div>
            <input
                type="range"
                min={props.min}
                max={props.max}
                step={props.step}
                value={showedValue}
                onChange={localChange}
                onMouseUp={e => {
                    let res = { ...e, target: { value: tickToStep(showedValue) } };
                    props.onChange(res);
                }}
                className="slider-range"
            />
        </div>
    );
}



interface SliderRangeProps {
    min: number
    max: number
    valueStart: number
    valueEnd: number
    onChangeStart: ((e: any) => void)
    onChangeEnd: ((e: any) => void)
    step?: number | undefined
    visualStep?: number | undefined
}

export function SliderRange(props: SliderRangeProps) {
    const [showedStartValue, setShowedStartValue] = useState(props.valueStart);
    const [showedEndValue, setShowedEndValue] = useState(props.valueEnd);

    useEffect(() => {
        setShowedStartValue(props.valueStart)
        setShowedEndValue(props.valueEnd)
    }, [props])


    let step = props.step;
    let visualStep = props.visualStep;
    if (step == null) step = 1;
    if (visualStep == null) visualStep = 1;

    const formatTick = (tick: number) => {
        //return <span className="text-xs text-gray-600 text-center">{tick}</span>;
        return <div className="slide-input-tick-container"><span className="text-xs text-gray-600 text-center">{tick}</span> </div>
    }

    const getTicks = (min: number, max: number, step?: number) => {
        const ticks: React.JSX.Element[] = [];

        for (let tick = min; tick <= max; tick += visualStep) {
            ticks.push(formatTick(tick));
        }
        return ticks;
    }


    const localChangeStart = (event) => {
        if (event.target.value >= showedEndValue) return;
        setShowedStartValue(event.target.value)
    }
    const localChangeEnd = (event) => {
        if (event.target.value <= showedStartValue) return;
        setShowedEndValue(event.target.value)
    }

    return (
        <div className={"pt-1 w-full"}>
            <div className="double_range_slider ">
                <div className="flex justify-between relative pt-2 px-2 w-full">
                    {getTicks(props.min, props.max, props.step).map(tick => (tick))}
                </div>
                <span className="range_track" id="range_track"></span>

                <input
                    type="range"
                    id="start_hour_input"
                    className="slider-range"
                    min={props.min}
                    max={props.max}
                    value={showedStartValue}
                    step={step}
                    onChange={localChangeStart}
                    onMouseUp={props.onChangeStart}
                />
                <input
                    type="range"
                    id="end_hour_input"
                    className=""
                    min={props.min}
                    max={props.max}
                    value={showedEndValue}
                    step={step}
                    onChange={localChangeEnd}
                    onMouseUp={props.onChangeEnd}
                />

                <div className="value slide-input-tick-container" style={{
                    left: ((showedStartValue / 24 * (95 - (document.getElementById('start_hour_input')?.clientWidth) / 100)) + 2) + "%"
                }}>{showedStartValue}h </div>

                <div className="value slide-input-tick-container" style={{
                    left: ((showedEndValue / 24 * (95 - (document.getElementById('start_hour_input')?.clientWidth) / 100)) + 2) + "%"
                }}> {showedEndValue}h </div>
            </div>
        </div>
    );
}